export default {
  inject: ['getGlobalDsv'],
  methods: {
    appendTableRow: function appendTableRow(widget) {
      this.designer.appendTableRow(widget);
    },
    appendTableCol: function appendTableCol(widget) {
      this.designer.appendTableCol(widget);
    },
    onContainerDragAdd: function onContainerDragAdd(evt, subList) {
      var newIndex = evt.newIndex;
      if (!!subList[newIndex]) {
        this.designer.setSelected(subList[newIndex]);
        this.designer.setNamesList(subList[newIndex]);
      }
      this.designer.emitHistoryChange();
      this.designer.emitEvent('field-selected', this.widget);
    },
    onContainerDragUpdate: function onContainerDragUpdate() {
      this.designer.emitHistoryChange();
    },
    checkContainerMove: function checkContainerMove(evt) {
      return this.designer.checkWidgetMove(evt);
    },
    selectWidget: function selectWidget(widget) {
      this.designer.setSelected(widget);
    },
    selectParentWidget: function selectParentWidget() {
      if (this.parentWidget) {
        this.designer.setSelected(this.parentWidget);
      } else {
        this.designer.clearSelected();
      }
    },
    moveUpWidget: function moveUpWidget() {
      this.designer.moveUpWidget(this.parentList, this.indexOfParentList);
      this.designer.emitHistoryChange();
    },
    moveDownWidget: function moveDownWidget() {
      this.designer.moveDownWidget(this.parentList, this.indexOfParentList);
      this.designer.emitHistoryChange();
    },
    cloneContainer: function cloneContainer(widget) {
      if (!!this.parentList) {
        var newCon = this.designer.cloneContainer(widget);
        this.parentList.splice(this.indexOfParentList + 1, 0, newCon);
        this.designer.setSelected(newCon);
        this.designer.emitHistoryChange();
      }
    },
    removeWidget: function removeWidget(_removeWidget) {
      var _this = this;
      if (!!this.parentList) {
        var widgetRefName = this.designer.selectedWidgetName;
        var nextSelected = null;
        if (this.parentList.length === 1) {
          if (!!this.parentWidget) {
            nextSelected = this.parentWidget;
          }
        } else if (this.parentList.length === 1 + this.indexOfParentList) {
          nextSelected = this.parentList[this.indexOfParentList - 1];
        } else {
          nextSelected = this.parentList[this.indexOfParentList + 1];
        }
        this.$nextTick(function () {
          _this.parentList.splice(_this.indexOfParentList, 1);
          _this.designer.setSelected(nextSelected);
          _this.designer.formWidget.deleteWidgetRef(widgetRefName, _removeWidget); //删除组件ref！！！
          _this.designer.emitHistoryChange();
        });
      }
    },
    setWidgetOption: function setWidgetOption(optionName, optionValue) {
      //通用组件选项修改API
      if (this.widget.options.hasOwnProperty(optionName)) {
        this.widget.options[optionName] = optionValue;
      }
    }
  }
};